import { Component, HostListener } from '@angular/core';
import { SessionService } from './common/services/session.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  private userActivity: any;
  private userInactive: Subject<any> = new Subject();

  constructor(private sessionService: SessionService) {
      this.setTimeout();
      this.userInactive.subscribe(() => this.sessionService.logout());
  }

  setTimeout() {
      this.userActivity = setTimeout(() => this.userInactive.next(undefined), 10 * 60 * 1000);
  }

  @HostListener('window:mousemove') refreshUserState() {
      clearTimeout(this.userActivity);
      this.setTimeout();
  }
}
